export default "__VITE_ASSET__CNVJpoTY__"